import React from 'react';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
import { CART_URL } from './constants';
import { trackAddToCart } from './MetaPixel';
import { useCurrency } from './currency/CurrencyContext';
import { Price } from './currency/Price';
export function FinalCta() {
  const {
    buildCartUrl
  } = useCurrency();
  return <section className="bg-[#a92d3d] px-5 py-16 text-white sm:px-8 sm:py-24" data-id="element-101" data-mp="15ckl4zoj0ke2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-102" data-mp="1jcd5md9gm4dl">
        <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#ffe1c9]" data-id="element-103" data-mp="1jasaomj8gjf7">
          Tu próxima semana puede sentirse diferente
        </p>
        <h2 className="font-display mt-4 text-5xl font-black leading-[0.95] tracking-[-0.055em] sm:text-6xl" data-id="element-104" data-mp="1t1wr7qok4cc5">
          🔥 Cocina una vez.
          <br data-id="element-105" data-mp="1o5y6cd2ftcgh" />
          Disfruta toda la semana.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-[#fff2e9]" data-id="element-106" data-mp="224o13m1sb01o">
          Deja de perder tiempo pensando qué cocinar cada día y empieza a
          disfrutar de una alimentación saludable, organizada y sin estrés.
        </p>
        <a href={buildCartUrl(CART_URL)} onClick={trackAddToCart} className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#143827] px-7 py-4 font-extrabold text-white shadow-[0_7px_0_#092318] transition-[background-color,transform] duration-150 hover:-translate-y-0.5 hover:bg-[#0b2a1c] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-[#ffe1c9] sm:w-auto" data-id="element-107" data-mp="n7yugx3kxand">
          Accede ahora por solo <Price amount={14.99} data-id="element-108" data-mp="1b1ywp9c3fxtq" />{' '}
          <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-109" data-mp="1fu9x0daqxlmt" />
        </a>
        <p className="mt-7 flex items-center justify-center gap-2 text-sm font-semibold text-[#fff0e4]" data-id="element-110" data-mp="1fwcwrp1pat4q">
          <CheckCircle2Icon aria-hidden="true" className="h-4 w-4" data-id="element-111" data-mp="1kvfo66ord0u8" />
          Pago único · Acceso inmediato · Bonos incluidos
        </p>
      </div>
    </section>;
}